import { useSelector } from "react-redux";
// import CommitteeMissionImg from "../../../assets/our-committee-image.jpg";

function CommitteeMission() {
  const committeeHomePage = useSelector(
    (x) => x?.committee?.getCommitteeHomePageIntegrationDataResponse?.data
  );
  const ImageURL = process.env.REACT_APP_API_IMAGE_URL;
  return (
    <section
      className="committee-mission"
      dangerouslySetInnerHTML={{
        __html: committeeHomePage?.committeeSectionOneDescription,
      }}
    ></section>
    // <section class="committee-mission" >
    //   <div class="container">
    //     <div class="row g-2 g-lg-5 align-items-center">
    //       <div
    //         class="col-lg-3 col-md-12 committee-title"
    //         data-sal="slide-up"
    //         data-sal-duration="900"
    //       >
    //         <h3>{committeeHomePage?.committe?.committeeName}</h3>
    //         <h2>{committeeHomePage?.committeeSectionOneTitle}</h2>
    //       </div>

    //       <div
    //         class="col-lg-5 col-md-12 committee-description"
    //         data-sal="slide-up"
    //         data-sal-duration="900"
    //       >
    //         <p
    //           dangerouslySetInnerHTML={{
    //             __html: committeeHomePage?.committeeSectionOneDescription,
    //           }}
    //         ></p>
    //       </div>

    //       <div
    //         class="col-lg-4 col-md-12"
    //         data-sal="slide-up"
    //         data-sal-duration="900"
    //       >
    //         <div class="committee-image">
    //           <img
    //             src={ImageURL + committeeHomePage?.committeeSectionOneImage}
    //             alt="Committee_Mission_Image"
    //           />
    //         </div>
    //       </div>
    //     </div>
    //   </div>
    // </section>
  );
}

export default CommitteeMission;
